import flatpickr from "flatpickr";
import flatpickrLanguages from "flatpickr/dist/l10n";
import Modal from "./modules/frontv2/Modal";
import SearchBar from "./modules/frontv2/SearchBar";
import MobileMenu from "./modules/frontv2/MobileMenu";
import MobileSearch from "./modules/frontv2/MobileSearch";
import Wish from "./modules/frontv2/Wish";
// import Glide, { Controls, Breakpoints, Swipe, Autoplay} from '@glidejs/glide/dist/glide.modular.esm'
// import ArrowDisabler from "./modules/frontv2/ArrowDisabler";
import * as Sentry from "@sentry/browser";
import { getUserLanguage } from "./modules/utils";
import { initDrops } from "./modules/common/drop";
import { initScroll } from "./modules/scrolling";
// import { initInputNumber } from "./modules/common/input-number";
import { initAutocomplete } from "./modules/frontv2/Autocomplete";
import { initMobileMenu } from "./modules/common/mobile-menu";
import { initSelects } from "./modules/common/selects";
import { initCookies } from "./modules/common/cookies";
import { initFormValidation } from "./modules/common/form-validation";
import { initGoogleEcommerce } from "./modules/google_ecommerce";
import { initGlide } from "./modules/common/glide";
import { initCollapsible } from "./modules/collapsible";
// import { initMapbox } from "./modules/frontv2/Mapbox";
import { initCommon } from "./modules/common/common";
import { initScrollSearchBar } from "./modules/frontv2/scrollSearchBar";
import { initSeeMoreContent } from "./modules/frontv2/seeMoreContent";
import MapHostSearch from "./modules/frontv2/MapHostSearch";
import { initScrollToTop } from "./modules/frontv2/ScrollToTop";
import { initSwiper } from "./modules/common/init-swiper";

document.addEventListener('DOMContentLoaded', () => {
  // Init Sentry JS
  if(document.body.dataset.env === 'prod') {
    Sentry.init({ dsn: 'https://b14c92e307604f4f8f454ebdd3eab1ef@sentry.io/1441102' });
  }

  flatpickr.localize(flatpickrLanguages[getUserLanguage()]);

  //common stuff
  initCommon();

  //init glide (carousel)
  initGlide();

  //Dropdowns and dropups
  initDrops();

  //Modal popups
  Modal.bindAllModals();

  //Init questions (faq) logic
  initCollapsible();

  //Header bar scroll logic
  initScroll();

  //Search bar logic (algolia)
  initAutocomplete();

  //Mobile menu
  initMobileMenu();

  //Init selects for langs (down the page)
  initSelects();

  //Init search logic
  new SearchBar('search-bar');
  new SearchBar('second-search-bar');

  //Mobile logic
  new MobileMenu();
  new MobileSearch();

  //Init wish bind buttons
  Wish.bindWishButtons();

  //Init cookies logic
  initCookies();

  //Init form validation + recaptcha
  initFormValidation();

  //Analytics
  initGoogleEcommerce();

  // initMapbox();

  // const glideEl = document.querySelector(".glide.glide-cities");
  // if(glideEl){
  //   const glide = new Glide(glideEl, {
  //     perView: glideEl.dataset.perView ? glideEl.dataset.perView : 3,
  //     gap: glideEl.dataset.gap ? glideEl.dataset.gap : 20,
  //     type: 'slider',
  //     rewind: true,
  //     bound: true,
  //     autoplay: glideEl.dataset.autoplay ? glideEl.dataset.autoplay : false,
  //     hoverpause: true,
  //     breakpoints: {
  //       600: {
  //         perView: glideEl.dataset.mobilePerView ? glideEl.dataset.mobilePerView : 1.3
  //       },
  //       800: {
  //         perView: glideEl.dataset.tabletPerView ? glideEl.dataset.tabletPerView : 2.3
  //       },
  //       1000: {
  //         perView: glideEl.dataset.desktopPerView ? glideEl.dataset.desktopPerView : 3.3
  //       },
  //       1300: {
  //         perView: 4.3
  //       },
  //       1700: {
  //         perView: 6.3
  //       },
  //       2000: {
  //         perView: 7.3
  //       }
  //     }
  //   });
  //   glide.mount({ Controls, Breakpoints, Swipe, ArrowDisabler, Autoplay });
  // }

  //init scroll search bar
  initScrollSearchBar();

  initSeeMoreContent();

  //init search map with hosts
  const searchMapHostsWrapper = document.getElementById('search-map-hosts');
  const searchWrapper = document.getElementById('search-wrapper');
  if(searchMapHostsWrapper && !searchMapHostsWrapper.hasAttribute('data-is-bot') && searchWrapper){
    if(typeof mapboxgl === 'undefined'){
      //on mobile, load mapbox when a click occurs on map (cause mapbox loading is heavy)
      if(searchMapHostsWrapper.hasAttribute('data-is-mobile') && !searchWrapper.hasAttribute('data-trigger-search-on-page-load')){
        let mapboxLoaded = false;

        window.addEventListener('click', (e) => {
          if(!mapboxLoaded){
            import('mapbox-gl').then(mapboxgl => {
              new MapHostSearch(searchMapHostsWrapper, mapboxgl);
              mapboxLoaded = true;

              if(['moreFilters', 'trigger-around-me', 'toggleLayout'].indexOf(e.target.id) !== -1){
                document.getElementById(e.target.id).dispatchEvent(new Event('click'));
              }
              else if(e.target.parentElement.id === 'toggleLayout'){
                document.getElementById('toggleLayout').dispatchEvent(new Event('click'));
              }
              else if(e.target.parentElement.id === 'trigger-around-me'){
                document.getElementById('trigger-around-me').dispatchEvent(new Event('click'));
              }
            });
          }
        });
      }
      //on desktop, load mapbox when page loads
      else{
        import('mapbox-gl').then(mapboxgl => {
          new MapHostSearch(searchMapHostsWrapper, mapboxgl);
        });
      }
    }
    //otherwise it means that mapboxgl was loaded through CDN
    else{
      new MapHostSearch(searchMapHostsWrapper, mapboxgl);
    }
  }

  //button to scroll to top
  initScrollToTop();

  //init Swiper
  initSwiper();
});
